import { defineComponent, watch } from '@vue/composition-api';
import { useExpose, withInstall } from '../util/index.js';
import useCountDown from '../util/use-count-down.js';

var Props = {
  time: {
    type: Number,
    "default": 0,
    required: true
  },
  format: {
    type: [Function, String],
    "default": ''
  },
  duration: {
    type: Number,
    "default": 1000
  }
};
var CountDown = defineComponent({
  name: 'm-count-down',
  props: Props,
  emits: ['finish'],
  setup: function setup(props, context) {
    var time = props.time,
        format = props.format,
        duration = props.duration;

    var _useCountDown = useCountDown({
      time: time,
      format: format,
      duration: duration,
      onFinish: function onFinish() {
        context.emit('finish');
      }
    }),
        current = _useCountDown.current,
        pause = _useCountDown.pause,
        start = _useCountDown.start,
        reset = _useCountDown.reset,
        resetOptions = _useCountDown.resetOptions;

    watch(function () {
      return props.time;
    }, function (newVlue) {
      reset(newVlue);
    });
    watch([function () {
      return props.format;
    }, function () {
      return props.duration;
    }], function (values) {
      resetOptions({
        format: values[0],
        duration: values[1]
      });
    }); // 暴露方法

    useExpose({
      pause: pause,
      start: start,
      reset: reset
    });
    return function () {
      var _context$slots$defaul, _context$slots;

      return (_context$slots$defaul = (_context$slots = context.slots)["default"]) === null || _context$slots$defaul === void 0 ? void 0 : _context$slots$defaul.call(_context$slots, current);
    };
  }
});
withInstall(CountDown);

export { CountDown as default };
//# sourceMappingURL=index.js.map
